export const MENU_LINKS = [
  { text: 'Menu', heading: true },
  { text: 'Produits', link: '/auth/produits', icon: 'fas fa-list' },
  { text: 'Caisses', link: '/auth/caisses', icon: 'fas fa-th' },
  { text: 'Caisses & Produits', link: '/auth/caisses-produits', icon: 'fas fa-project-diagram' },
  { text: 'Evenements', link: '/auth/evenements', icon: 'fas fa-glass-cheers' },
];
